/* Patamora v7: el rodillo del hero se arrastra con el dedo (va pegado al dedo, conserva el impulso
   al soltar y se puede volver a agarrar a mitad de camino) y la ventana del −10 % sale de su pestaña. */

const buzz = (ms) => {
  try {
    navigator.vibrate?.(ms);
  } catch (e) {
    /* sin vibración */
  }
};

// Muelle sin rebote (amortiguación 1): sale del valor que hay en pantalla y con la velocidad del dedo.
// `response` es lo rápido que llega, en segundos. Devuelve una función para pararlo si lo agarran otra vez.
function spring(from, to, velocity, onFrame, { response = 0.4, damping = 1 } = {}) {
  const k = ((2 * Math.PI) / response) ** 2;
  const c = (4 * Math.PI * damping) / response;
  let x = from;
  let v = velocity;
  let last = performance.now();
  let id = 0;
  const step = (now) => {
    let dt = Math.min(0.064, (now - last) / 1000);
    last = now;
    while (dt > 0) {
      const h = Math.min(dt, 0.004);
      v += (-k * (x - to) - c * v) * h;
      x += v * h;
      dt -= h;
    }
    if (Math.abs(x - to) < 0.0005 && Math.abs(v) < 0.01) {
      onFrame(to);
      return;
    }
    onFrame(x);
    id = requestAnimationFrame(step);
  };
  id = requestAnimationFrame(step);
  return () => cancelAnimationFrame(id);
}

// Dónde acabaría el gesto si se dejara correr, igual que la inercia del scroll.
const project = (velocity, rate = 0.998) => ((velocity / 1000) * rate) / (1 - rate);

// Pasado el borde, el rodillo se resiste cada vez más en vez de pararse en seco.
const rubberband = (over, dim, c = 0.55) => (over * dim * c) / (dim + c * Math.abs(over));

/* ---------- Hero: arrastrar el rodillo ---------- */

function initRoller(section) {
  const scene = section.querySelector('.pm-scene');
  if (!scene || typeof section.pmUpdate !== 'function') return;
  scene.querySelectorAll('img').forEach((img) => (img.draggable = false));

  // Los avisos dicen que el rodillo se puede coger (el de móvil lo crea patamora-extras.js).
  const touch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  const swipeText = scene.querySelector('.pm-swipe__text');
  if (swipeText) swipeText.textContent = touch ? 'Arrastra el rodillo y limpia el sofá' : 'Arrastra el rodillo o haz scroll';
  const hint = section.querySelector('.pm-hero__hint');
  if (hint) hint.lastChild.textContent = 'Arrastra el rodillo o haz scroll';

  let grab = null;
  let history = [];
  let stop = null;
  let wasClean = section.classList.contains('is-clean');

  // El rodillo recorre el 86 % del ancho de la escena (patamora-fixes.css).
  const travel = () => scene.getBoundingClientRect().width * 0.86;

  const set = (p) => {
    section.pmDragP = p;
    section.pmUpdate();
    const clean = section.classList.contains('is-clean');
    if (clean && !wasClean) buzz(15);
    wasClean = clean;
  };

  // Sofá limpio a mano: sobra el scroll que solo movía el rodillo, así la página baja sin frenarse.
  const finish = () => {
    if (section.classList.contains('is-done')) return;
    const stage = section.querySelector('.pm-hero__stage');
    const before = stage.getBoundingClientRect().top;
    section.classList.add('is-done');
    const shift = stage.getBoundingClientRect().top - before;
    if (shift) {
      const wrapper = document.querySelector('.page-wrapper');
      const el = wrapper && wrapper.scrollHeight > wrapper.clientHeight + 4 ? wrapper : document.scrollingElement;
      el.scrollTop += shift;
    }
  };

  scene.addEventListener('pointerdown', (e) => {
    if (e.button !== 0) return;
    stop?.();
    stop = null;
    // Se sigue desde donde está en pantalla, aunque estuviera volviendo solo.
    const current = parseFloat(section.style.getPropertyValue('--p')) || 0;
    grab = { id: e.pointerId, x: e.clientX, y: e.clientY, p: current, dragging: false };
    history = [{ x: e.clientX, t: e.timeStamp }];
  });

  scene.addEventListener('pointermove', (e) => {
    if (!grab || e.pointerId !== grab.id) return;
    const dx = e.clientX - grab.x;
    const dy = e.clientY - grab.y;
    if (!grab.dragging) {
      // Movimiento vertical: es scroll, se deja pasar.
      if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
        grab = null;
        return;
      }
      if (Math.abs(dx) < 10) return;
      grab.dragging = true;
      grab.x += Math.sign(dx) * 10; // empieza a contar desde el umbral: sin salto y sin perder recorrido
      scene.setPointerCapture(e.pointerId);
      section.classList.add('is-dragging');
    }
    history.push({ x: e.clientX, t: e.timeStamp });
    if (history.length > 6) history.shift();

    const w = travel();
    let px = grab.p * w + (e.clientX - grab.x);
    if (px > w) px = w + rubberband(px - w, w);
    else if (px < 0) px = rubberband(px, w);
    set(px / w);
  });

  const release = (e) => {
    if (!grab || e.pointerId !== grab.id) return;
    const dragged = grab.dragging;
    grab = null;
    if (!dragged) return;
    section.classList.remove('is-dragging');

    const first = history[0];
    const last = history[history.length - 1];
    const still = e.timeStamp - last.t > 100;
    const velocity = still ? 0 : ((last.x - first.x) / Math.max(1, last.t - first.t)) * 1000;
    const w = travel();
    const p = section.pmDragP || 0;
    // Basta con empezar: si el gesto acabaría pasado el 15 %, el rodillo termina solo de limpiar.
    // Solo vuelve atrás si apenas se movió o se lanzó hacia la izquierda.
    const target = p + project(velocity) / w > 0.15 ? 1 : 0;
    stop = spring(p, target, velocity / w, (x) => {
      set(x);
      if (x === 1) finish();
    });
  };
  scene.addEventListener('pointerup', release);
  scene.addEventListener('pointercancel', release);
}

document.querySelectorAll('[data-pm-scene]').forEach(initRoller);

/* ---------- Copiar el hashtag de "Peludos de Patamora" ---------- */

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pm-copy-text]');
  if (!button) return;
  const label = button.querySelector('[data-pm-copy-label]') || button;
  const text = button.dataset.pmCopyText;
  try {
    await navigator.clipboard.writeText(text);
    label.textContent = '¡Copiado! Pégalo en tu post';
    buzz(10);
  } catch (e) {
    label.textContent = text;
  }
  clearTimeout(button.pmTimer);
  button.pmTimer = setTimeout(() => (label.textContent = text), 2200);
});

/* ---------- La ventana del −10 % crece desde su pestaña ---------- */

const welcome = document.querySelector('[data-pm-welcome]');
const welcomeTab = document.querySelector('[data-pm-welcome-tab]');
if (welcome && welcomeTab) {
  welcomeTab.addEventListener('click', () => welcome.classList.add('is-from-tab'), { capture: true });
  welcome.addEventListener('close', () => welcome.classList.remove('is-from-tab'));
}
